export const FEDERAL_LOW_248_GUID = '0af43830-8413-1fdc-8184-1411c0f30045';
